import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import { getDate, getHour } from '../../utils/DateUtil'
import { Card, CardContent } from '@mui/material'

const LastUpdate = ({
    element = undefined,
    withHour = false,
}) => {
    const label = (() => {
        if (element) {
            const updateLogin = element.updateLogin ? element.updateLogin : i18n.unknown
            const updateDate = element.updateDate ? getDate(element.updateDate, 'DD/MM/YYYY') : i18n.unknownDate
            if (withHour) {
                const updateHour = element.updateDate ? getHour(element.updateDate, 'HH:mm') : i18n.unknownHour
                return `${i18n.lastUpdate} ${i18n.by} ${updateLogin} ${i18n.atDate} ${updateDate} ${i18n.atHour} ${updateHour}`
            }
            return `${i18n.lastUpdate} ${i18n.by} ${updateLogin} ${i18n.atDate} ${updateDate}`
        }
        return i18n.noUpdate
    })()

    return <h6>{label}</h6>
}

LastUpdate.propTypes = {
    element: PropTypes.shape({
        updateLogin: PropTypes.string,
        updateDate: PropTypes.number,
    }),
    withHour: PropTypes.bool,
}

const LastUpdateCard = ({
    element = undefined,
    withHour = false,
    className,
}) => {
    return (
        <Card className={className}>
            <CardContent>
                <LastUpdate element={element} withHour={withHour} className={className}/>
            </CardContent>
        </Card>
    )
}

LastUpdateCard.propTypes = {
    element: PropTypes.shape({
        updateLogin: PropTypes.string,
        updateDate: PropTypes.number,
    }),
    withHour: PropTypes.bool,
    className: PropTypes.string,
}

export { LastUpdateCard, LastUpdate }